import { combineReducers } from 'redux';
import mainReducer from '@/bit/reducers/next13.reducers.main-reducer';
import modalsReducer from '@/bit/reducers/next13.reducers.modals-reducer';
import headerReducer from '@/bit/reducers/next13.reducers.header-reducer';

const REDUCERS_LIST = {
  main: mainReducer,
  modals: modalsReducer,
  header: headerReducer,
}

const rootReducers = () =>
  combineReducers({
    ...REDUCERS_LIST,
  });

export default rootReducers;
